import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { type commonAttributesType } from '../../ai-answer-dialog/types';

export const onCuratedDefinitionSeeEditHistoryButtonClicked = (
	props: commonAttributesType,
): AnalyticsEventPayload => {
	const { query, answerString, extraAttributes, source } = props;
	const { contentId, readingAidsSessionId } = extraAttributes || {};

	return {
		action: 'clicked',
		actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
		source,
		eventType: 'ui',
		attributes: {
			contentId,
			readingAidsSessionId,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
